module.exports = __webpack_public_path__ + "img/4-4.d081bcb6.svg";